import { type FC } from "react";
import * as styles from "./styles.css";

export type EditLinkProps = {
  url: string;
};

export const EditPageLink: FC<EditLinkProps> = ({ url }) => (
  <a className={styles.link} href={url}>
    編集する
  </a>
);
